
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personalisation",
      function () {
        return require("private-next-pages/personalisation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personalisation"])
      });
    }
  